import yup from './yup'
import moment from 'moment/moment'
import { urlRegExp } from 'schemas/index'

export const confFormSchema = yup.object().shape({
  confName: yup.string().label('Conference Name').trimmedRequired('Conference Name is required.'),
  confCode: yup.string().label('Conference Code').trimmedRequired('Conference Code is required'),
  exploreConfMenuItem: yup
    .string()
    .label('Explore Conference Menu Item')
    .test('Item is required', 'Explore Conference Menu Item is required', function (value) {
      const exploreConfURL = this.parent.exploreConfURL
      return !(!value && exploreConfURL)
    }),
  exploreConfURL: yup
    .string()
    .label('Explore Conference URL')
    .test('Url is required', 'Explore Conference URL is required', function (value) {
      const exploreConfURL = this.parent.exploreConfMenuItem
      return !(!value && exploreConfURL)
    })
    .when('exploreConfMenuItem', {
      is: (value) => value,
      then: yup
        .string()
        .label('Explore Conference URL')
        .matches(urlRegExp, 'Explore Conference URL must be valid URL')
        .required(),
      otherwise: yup.string().notRequired()
    }),
  timezone: yup.string().label('Conference Timezone').required('Conference Timezone is required'),
  startDate: yup.date().label('Start Date').required().typeError('Invalid date'),
  endDate: yup
    .date()
    .label('End date')
    .typeError('Invalid date')
    .test(
      'Date Check',
      { errType: 'Date', msg: 'End date must be after start date.' },
      function (value) {
        const startDate = moment(this.parent.startDate)
        const endDate = moment(value)
        return endDate.isSameOrAfter(startDate, 'date')
      }
    )
    .required(),
  viewableUntil: yup.date().label('Viewable Until Date').required().typeError('Invalid date'),
  is24hrFormat: yup.bool().label('Use 24hr Format').required(),
  isActive: yup.bool().label('Status').required(),
  posterPrefix: yup
    .string()
    .min(2)
    .max(3)
    .matches(/^[a-zA-Z]+$/, 'Poster Number Prefix can only contain letters.')
    .label('Poster Session Prefix')
    .trimmedRequired('Poster Number Prefix is required.'),
  abstractPrefix: yup
    .string()
    .min(2)
    .max(3)
    .matches(/^[a-zA-Z]+$/, 'Abstract Number Prefix can only contain letters.')
    .label('Abstract Prefix')
    .trimmedRequired('Abstract Number Prefix is required.')
})
